import { render, staticRenderFns } from "./IchingCircuits.vue?vue&type=template&id=83ae4252&"
import script from "./IchingCircuits.vue?vue&type=script&lang=js&"
export * from "./IchingCircuits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports